exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2XcG5{display:inline-block;font-weight:700;padding:5px;border-radius:2px;color:#000;font-weight:600;font-size:16px;background:#ffd906;cursor:pointer;z-index:6;position:relative}._2XcG5:hover{text-decoration:underline}", ""]);

// exports
exports.locals = {
	"priceMonthly": "_2XcG5"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/LeasingOnlineBanner/LeasingWithCalculatorButton/LeasingWithCalculatorButton.css
// module id = 1720
// module chunks = 15 20 21 23 32 33 38